import { Folder, FolderOpen } from 'lucide-react'

/** A folder glyph in the folder's colour (grey when it has none). */
export default function FolderIcon({ color, open = false, size = 15 }: { color: string | null; open?: boolean; size?: number }) {
  const Icon = open ? FolderOpen : Folder
  return <Icon size={size} className="shrink-0" style={{ color: color ?? '#94a3b8' }} />
}
